export default __webpack_public_path__ + "static/media/toastrInfoIcon.4d51bcb5.svg";